import { render, staticRenderFns } from "./DataTableToggleColumns.vue?vue&type=template&id=b6c56d44&scoped=true"
import script from "./DataTableToggleColumns.vue?vue&type=script&lang=js"
export * from "./DataTableToggleColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c56d44",
  null
  
)

export default component.exports